var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvLayoutBottomBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 157,
    viewBox: "0 0 132 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2118_112233",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 132,
    height: 157
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.150391 0.632812H131.605V156.612H0.150391V0.632812Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2118_112233)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2118_112233",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 178,
    height: 173
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9992 1.91211L178.352 47.3271L131.536 173.272L1.18359 127.857L47.9992 1.91211Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2118_112233)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2118_112233",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 131,
    height: 173
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.486 173.254L1.18359 127.857L47.9992 1.91211L131.486 173.254Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2118_112233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9992 1.91211L178.352 47.3271L131.536 173.272L1.18359 127.857L47.9992 1.91211Z",
    fill: "#0000E1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvLayoutBottomBold);
export default __webpack_public_path__ + "static/media/adv-layout-bottom-bold.1ef762d00a8c5247aed3c618eddb9134.svg";
export { ForwardRef as ReactComponent };